// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"fe468c8f","140":"9ef9f9a5","169":"d274868e","200":"698574de","202":"0cc5a7a8","276":"68600b72","371":"64ecd205","469":"2ef8b274","491":"67fdcab7","696":"1bd7ab8f","725":"298e4876","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};